<app-dialog-header title="Modifier le document '{{title}}'" />
<div mat-dialog-content style="padding: 8px;">

  <div class="section-admin-subtitle">
    <app-icon type="mat" icon="arrow_right" color="primary"></app-icon>
    Remplacer par :
  </div>

  <div style="width: 80%; margin: auto; display: flex; flex-direction: column; gap: 10px;">
    <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;" />

    @if(!newFile){
    <button mat-raised-button color="accent-lighter" (click)="fileInput.click()" type="button">
      <mat-icon>upload_file</mat-icon>
      Choisir un fichier
    </button>
    }@else {
    <div class="selected-file-info">
      <mat-icon color="accent">check_circle</mat-icon>
      <span>{{ newFile.name }}</span>
      <button mat-icon-button (click)="clearFileSelection()" type="button" matTooltip="Annuler la sélection">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    }

  </div>

  <div class="section-admin-subtitle">
    <app-icon type="mat" icon="arrow_right" color="primary"></app-icon>
    Renommer en :
  </div>
  <mat-form-field style="width: 80%; margin: auto; display: block;" subscriptSizing="dynamic">
    <input matInput [(ngModel)]="file.name">
  </mat-form-field>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="null" type="button" color="warn">Annuler</button>
  <button mat-raised-button [mat-dialog-close]="{ file: file, newFile: newFile }" cdkFocusInitial
    color="primary">Valider</button>
</div>